export { default } from './Amplitude';
